'use client';

export function str(value) {
  if (typeof value === 'string') {
    return value;
  }
  if (value) {
    return value.toString();
  }
  return '';
}

export const validateEmail = (email, allowEmpty) => {
  const MAX_EMAIL_LENGTH = 254;

  let newEmail = str(email).trim();
  newEmail = newEmail.replace(/^[\s(<{[]+/, '');
  newEmail = newEmail.replace(/[\s)>}\]]+$/, '');

  if (!newEmail && allowEmpty) {
    return {valid: true, value: ''};
  }

  if (!newEmail && !allowEmpty) {
    return {valid: false, message: 'Email address is required'};
  }

  if (newEmail.length > MAX_EMAIL_LENGTH) {
    return {
      valid: false,
      message: `Email address max length is ${MAX_EMAIL_LENGTH}`,
    };
  }

  // to match backEnd validation
  // Server enforced regex
  const serverRegex =
    /(^\s*[a-zA-Z0-9."!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9_-]+\.[a-zA-Z0-9-.]+\s*$)/gm;
  // Browser enforced regex
  const browserRegex =
    /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gm;
  const isValidFormat = browserRegex.exec(newEmail) && serverRegex.exec(newEmail);

  if (!isValidFormat) {
    return {valid: false, message: 'Invalid email address'};
  }

  return {valid: true, value: newEmail};
};
